import {useMemo, useCallback} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {setIsTimeout, selectIsTimeout} from '../slices/timeoutSlice'

export const useTimeoutContext = () => {
  const dispatch = useDispatch()
  const isTimeout = useSelector(selectIsTimeout)

  const setIsTimeoutCallback = useCallback(
    (value) => {
      dispatch(setIsTimeout(value))
    },
    [dispatch]
  )

  const values = useMemo(
    () => ({
      isTimeout,
      setIsTimeout: setIsTimeoutCallback
    }),
    [isTimeout, setIsTimeoutCallback]
  )

  return values
}
